export default __webpack_public_path__ + "static/media/op-manager-report-light.d9f8bf44.svg";